import { render, staticRenderFns } from "./RecommendModule.vue?vue&type=template&id=49bc96c6&scoped=true&"
import script from "./RecommendModule.vue?vue&type=script&lang=js&"
export * from "./RecommendModule.vue?vue&type=script&lang=js&"
import style0 from "./RecommendModule.vue?vue&type=style&index=0&id=49bc96c6&lang=less&scoped=true&"
import style1 from "./RecommendModule.vue?vue&type=style&index=1&id=49bc96c6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49bc96c6",
  null
  
)

export default component.exports